<p-toast></p-toast>

<section>
    <div class="admin-surface cluster-selection" [hidden]="isClusterChosen">

        <div class="cluster-section__header">
            <h3>Escolha um cluster para a sua nova campanha:</h3>
            <div class="cluster-section__action">
                <button class="admin-btn admin-btn--primary" (click)="isClusterChosen = true"
                    [disabled]="!campaignForm.get('cluster')?.value">Próximo</button>
            </div>
        </div>


        <div class="admin-detail-card">
            <p-table [value]="clusters" [paginator]="true" [rows]="rowsPerPage" [totalRecords]="totalClusters"
                [lazy]="true" [loading]="isFetchingClusters" (onLazyLoad)="onLazyLoad($event)"
                styleClass="admin-table hoverable">
                <ng-template pTemplate="header">
                    <tr>
                        <th>ID</th>
                        <th>Nome</th>
                        <th>Descrição</th>
                        <th>Query</th>
                        <th>Usuários</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-cluster>
                    <tr (click)="selectCluster(cluster)"
                        [class.selected-row]="campaignForm.get('cluster')?.value?.id === cluster.id">
                        <td>{{cluster.id}}</td>
                        <td>{{cluster.name}}</td>
                        <td>{{cluster.description}}</td>
                        <td>{{cluster.sql_query}}</td>
                        <td>{{cluster.total_users}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <div class="admin-surface admin-surface__section" [hidden]="!isClusterChosen">
        @if (campaignForm.get('cluster')?.value; as selectedCluster) {
        <div class="admin-detail-card">
            <div class="admin-detail-card__header">
                <h4>Cluster</h4>
                <div class="admin-detail-card__action">
                    <button class="admin-btn admin-btn--primary" (click)="isClusterChosen = false">Voltar</button>
                </div>
            </div>

            <div class="info">
                <span>ID</span>
                <strong>{{selectedCluster.id}}</strong>
            </div>
            <div class="info">
                <span>Nome</span>
                <strong>{{selectedCluster.name}}</strong>
            </div>
            <div class="info">
                <span>Descrição</span>
                <strong>{{selectedCluster.description || "N/A"}}</strong>
            </div>
            <div class="info no-border">
                <span>Total de usuários</span>
                <strong>{{selectedCluster.total_users}}</strong>
            </div>
        </div>
        } @else {
        <p>Nenhum cluster selecionado ainda.</p>
        }
        <div class="admin-surface__header" style="margin-top: 0.9rem ;">
            <h3>Nova campanha:</h3>
        </div>
        <form class="admin-form" [formGroup]="campaignForm" (ngSubmit)="onSubmit()">
            <label for="title">Título
                <input id="title" type="text" formControlName="title" />

                @if (campaignForm.get('title')?.invalid && campaignForm.get('title')?.touched) {
                <small class="error-text">O título é obrigatório.</small>
                }
            </label>
            <label for="channels">Canais de Envio
                <p-multiSelect id="channels" [options]="channelOptions" [filter]="false" [showToggleAll]="false"
                    formControlName="channels" optionLabel="label" optionValue="value" placeholder="Selecione os canais"
                    display="chip" [style]="{'width': '100%'}" scrollHeight="150px" appendTo="body">
                </p-multiSelect>
            </label>
            <div class="channels_section">
                <div formGroupName="push_settings" *ngIf="hasChannel('PUSH')"
                    class="admin-surface admin-surface__section">
                    <h5>Push:</h5>
                    <label for="message">Mensagem
                        <textarea id="message" type="text" formControlName="message">Mensagem de marketing...</textarea>

                        @if (campaignForm.get('message')?.invalid && campaignForm.get('message')?.touched) {
                        <small class="error-text">A mensagem é obrigatória.</small>
                        }
                    </label>
                    <label>URL da Imagem da notificação push <input formControlName="image_url" /></label>
                </div>

                <div formGroupName="email_settings" *ngIf="hasChannel('EMAIL')"
                    class="admin-surface admin-surface__section">
                    <h5>E-mail:</h5>
                    <label> Template de E-mail
                        <p-dropdown [options]="emailTemplateOptions" formControlName="email_template"
                            placeholder="Selecione um template" (onChange)="onTemplateChange($event.value)">
                        </p-dropdown>
                    </label>
                    <div formGroupName="email_template_variables" *ngIf="visibleEmailVariables.length > 0">
                        <label *ngFor="let variable of visibleEmailVariables" [for]="variable.key">
                            {{ variable.key }}
                            <input [id]="variable.key" [formControlName]="variable.key"
                                [placeholder]="variable.fallback_value" />
                        </label>
                    </div>
                </div>

                <div formGroupName="whatsapp_settings" *ngIf="hasChannel('WHATSAPP')"
                    class="admin-surface admin-surface__section">
                    <h5>WhatsApp:</h5>
                    <label>Template de WhatsApp
                        <p-dropdown [options]="whatsappTemplateOptions" formControlName="whatsapp_template"
                            placeholder="Selecione um template" [loading]="isFetchingWhatsAppTemplates"
                            (onChange)="onWhatsAppTemplateChange($event.value)">
                        </p-dropdown>
                    </label>
                    <div formGroupName="whatsapp_template_variables" *ngIf="whatsappVariables.length > 0">
                        <p *ngIf="isFetchingWhatsAppVariables">Carregando variáveis...</p>
                        <div *ngFor="let variable of whatsappVariables" class="whatsapp-variable-group">
                            <p><strong>{{ variable.component }}</strong> —
                                <code>{{ '{{' + variable.placeholder + '}}' }}</code>
                            </p>
                            <label [for]="getWhatsAppControlName(variable) + '_dynamic'">Variável dinâmica
                                <input [id]="getWhatsAppControlName(variable) + '_dynamic'"
                                    [formControlName]="getWhatsAppControlName(variable) + '_dynamic'"
                                    placeholder="ex: first_name" />
                            </label>
                            <label [for]="getWhatsAppControlName(variable) + '_fallback'">Fallback
                                <input [id]="getWhatsAppControlName(variable) + '_fallback'"
                                    [formControlName]="getWhatsAppControlName(variable) + '_fallback'"
                                    placeholder="Valor caso o campo seja vazio" />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-actions">
                <button type="submit" class="admin-btn admin-btn--primary" [disabled]="campaignForm.invalid">
                    Criar Campanha
                </button>
            </div>
        </form>


    </div>


</section>